import Vue from 'vue'

const Cryptr = require('cryptr');
const cryptr = new Cryptr('lAbSeCrEtDaTaEnCrYpT');

Vue.prototype.$encryptString = function (data) {
  return cryptr.encrypt(data)
}

Vue.prototype.$decryptString = function (data) {
  return cryptr.decrypt(data)
}


// WEBPACK FOOTER //
// ./src/util.js